<template>
  <div>
    <HeroSection />
    <GoalSection class="py-sm-8" />
    <CertifiedModelsSection class="py-sm-8" />
    <ServicesSection class="py-sm-8" />
    <RepairNetworkSection class="py-sm-8" />
    <AboutSection />
    <TestimonialsSection class="py-sm-8" />
    <GallerySection class="py-sm-8" />
    <CertificationsSection class="py-sm-8" />
  </div>
</template>
